var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressRunner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9689 2.40349C13.9689 1.07603 15.1243 0 16.5494 0C17.9746 0 19.13 1.07611 19.13 2.40349C19.13 3.73096 17.9746 4.80699 16.5494 4.80699C15.1243 4.80699 13.9689 3.73087 13.9689 2.40349ZM23.7333 9.41895C23.3152 8.93521 22.5556 8.85881 22.0361 9.24802L18.9242 10.5724L16.4 5.74894L13.7891 4.31275L8.05579 4.19707C7.4479 4.17776 6.86939 4.4412 6.51253 4.9L4.31739 7.72226C3.96676 8.17308 4.07582 8.80349 4.56077 9.12889L4.57853 9.14081C5.06509 9.4673 5.74401 9.3622 6.09105 8.90675L8.08067 6.29531L11.296 6.80398L6.44187 15.9146L1.73682 13.9248C1.227 13.6817 0.602158 13.8513 0.312453 14.3116L0.148491 14.5721C-0.153202 15.0514 0.0194132 15.6677 0.534014 15.9489L6.00803 18.9388C6.62052 19.2734 7.40554 19.1173 7.81792 18.579C9.01406 17.0175 11.2757 14.0864 11.3687 14.1269L15.5793 16.7563L15.6017 22.1383C15.6017 22.1383 15.5957 23.5825 16.3079 23.8826C16.4972 23.9623 16.6952 24 16.8904 24C17.4291 24 17.944 23.7119 18.1806 23.2249L18.734 16.657C18.734 16.657 18.7459 15.2256 18.0442 14.9199L13.4858 11.6403L15.2307 9.26556L17.6325 12.7535C18.0589 13.2062 18.7928 13.2654 19.2966 12.8878L23.5496 10.9997C24.0691 10.6103 24.1512 9.9026 23.7333 9.41895Z",
    fill: "#4D8BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressRunner);
export default __webpack_public_path__ + "static/media/progress-runner.7ee4d1cfc40474a5de55f0efd6c7d253.svg";
export { ForwardRef as ReactComponent };